/**
 * Destino: fuso e janela de horário comercial.
 */
import React from 'react';
import Select from '../../../../components/ui/Select';
import Input from '../../../../components/ui/Input';
import Switch from '../../../../components/ui/Switch';
import { FOLLOW_UP_TIMEZONE_OPTIONS } from '../followUp.constants';

interface FollowUpBusinessHoursFieldsProps {
    fieldId: string;
    timezone: string;
    onTimezoneChange: (timezone: string) => void;
    businessHoursStart: string;
    onBusinessHoursStartChange: (value: string) => void;
    businessHoursEnd: string;
    onBusinessHoursEndChange: (value: string) => void;
    businessHoursWeekdaysOnly: boolean;
    onBusinessHoursWeekdaysOnlyChange: (value: boolean) => void;
}

export default function FollowUpBusinessHoursFields({
    fieldId,
    timezone,
    onTimezoneChange,
    businessHoursStart,
    onBusinessHoursStartChange,
    businessHoursEnd,
    onBusinessHoursEndChange,
    businessHoursWeekdaysOnly,
    onBusinessHoursWeekdaysOnlyChange,
}: FollowUpBusinessHoursFieldsProps) {
    return (
        <section className="flex flex-col gap-s3" aria-labelledby={`${fieldId}-hours`}>
            <h4
                id={`${fieldId}-hours`}
                className="text-xs font-semibold uppercase tracking-wide text-muted"
            >
                Horário comercial
            </h4>
            <Select
                label="Fuso horário"
                value={timezone}
                onChange={(event) => onTimezoneChange(event.target.value)}
                options={[...FOLLOW_UP_TIMEZONE_OPTIONS]}
                aria-label="Fuso horário da organização"
            />
            <div className="grid grid-cols-1 gap-s4 sm:grid-cols-2">
                <Input
                    type="time"
                    label="Início"
                    value={businessHoursStart}
                    onChange={(event) => onBusinessHoursStartChange(event.target.value)}
                />
                <Input
                    type="time"
                    label="Fim"
                    value={businessHoursEnd}
                    onChange={(event) => onBusinessHoursEndChange(event.target.value)}
                />
            </div>
            <Switch
                label="Somente dias úteis (seg–sex)"
                checked={businessHoursWeekdaysOnly}
                onChange={onBusinessHoursWeekdaysOnlyChange}
            />
            <p className="text-xs text-muted">
                Follow-ups só saem neste horário no fuso da organização. Fora dele, o envio é adiado.
            </p>
        </section>
    );
}
